import React from "react"
import { motion, useReducedMotion } from "framer-motion"
import LandingNav from "../components/landing/LandingNav"
import LandingFooter from "../components/landing/LandingFooter"
import LandingButton from "../components/landing/LandingButton"
import LandingSparkleBadge from "../components/landing/LandingSparkleBadge"

const NotFound: React.FC = () => {
  const prefersReducedMotion = useReducedMotion()

  return (
    <div className="bg-base-100">
      <LandingNav />

      <section className="relative flex min-h-[calc(100vh-80px)] items-center justify-center overflow-hidden bg-[#0a0a12] px-4 py-28 md:py-32">
        <div className="absolute inset-0 bg-gradient-to-b from-[#001a4d]/90 via-[#0d0d0d]/70 to-[#0d0d0d]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_20%,rgba(158,126,67,0.22),transparent_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_80%_80%,rgba(46,119,255,0.12),transparent_50%)]" />

        {!prefersReducedMotion && (
          <motion.div
            className="pointer-events-none absolute -left-24 top-1/3 h-64 w-64 rounded-full bg-dc-primary-900/25 blur-[100px]"
            animate={{ x: [0, 24, 0], y: [0, -16, 0] }}
            transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
          />
        )}

        <div className="relative z-10 mx-auto flex w-full max-w-2xl flex-col items-center gap-6 text-center">
          <LandingSparkleBadge label="Page not found" className="border border-[#9e7e43]/20 bg-[#9e7e43]/10" />

          <p
            aria-hidden
            className="pointer-events-none select-none font-outfit text-[7rem] font-bold leading-none tracking-tighter text-white/[0.07] md:text-[9rem]"
          >
            404
          </p>

          <div className="-mt-16 flex flex-col gap-4 md:-mt-20">
            <h1 className="font-outfit text-3xl font-semibold tracking-tight text-white md:text-4xl">
              This page doesn&apos;t exist
            </h1>
            <p className="mx-auto max-w-md font-dm-sans text-base leading-7 tracking-wide text-white/70">
              The link may be broken, or the page may have moved as we&apos;ve refreshed our site. Let&apos;s get you
              back on track.
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 pt-2">
            <LandingButton href="/">Back to Home</LandingButton>
            <LandingButton href="/about" variant="outline">
              About Us
            </LandingButton>
            <LandingButton href="/#our-locations" variant="outline">
              Find a Location
            </LandingButton>
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  )
}

export default NotFound
